import { useEffect, useRef, useState } from "react";

interface WindArrowProps {
    children?: React.ReactNode;
    rotation: number;
    editable?:boolean; 
    inputDivClassName?:string;
    inputClassName?:string;
    onEditStart? : () => void,
    onEditEnd? : () => void,
    onRotationChanged? : (v:number) => void;
}

function WindArrow(props:WindArrowProps) {
    const [isEditing, setIsEditing] = useState(false);
    const internalRef = useRef<HTMLInputElement>(null);
    const arrowStyle = {
                        width: '35px', 
                        height: '35px',
                        marginLeft: '5px',
                        transform: `rotate(${props.rotation+180}deg)`,
                        cursor: props.editable?'pointer':''
                      };
  useEffect(() => {
    if (isEditing && internalRef.current) {
      internalRef.current.focus();
    }
  }, [isEditing]);


  const handleEdit = () => {
    if(props.editable) {
        setIsEditing(true);
        if(props.onEditStart!=null) {
          props.onEditStart();
        }
    }
  };

  function handleKeyDown(event: React.KeyboardEvent<HTMLInputElement>) {
    if(event.key == 'Enter') {
      try {
        let v = (internalRef.current?.value || 'error').replace(',','.');
        let newVal = parseFloat(v);     
        if(!isNaN(newVal)) {
          if(props.onRotationChanged!=null) {
            props.onRotationChanged(newVal);
          }
        }
      } catch (err) {      
      }
      setIsEditing(false);
      if(props.onEditStart!=null) {
        props.onEditStart();
      }
    }
  }

  function handleBlur(event: React.ChangeEvent<HTMLInputElement>) {
    try {
        let v = (internalRef.current?.value || 'error').replace(',','.');
        let newVal = parseFloat(v);   
        if(!isNaN(newVal)) {
          if(props.onRotationChanged!=null) {
            props.onRotationChanged(newVal);
          }
        }
    } catch (err) {      
    }
    setIsEditing(false);
    if(props.onEditEnd!=null) {
      props.onEditEnd();
    }
  };

  return isEditing ? (
    <div className={props.inputDivClassName}> 
      <input className={props.inputClassName}
              onBlur={handleBlur} 
              onKeyDown={handleKeyDown}              
              defaultValue={props.rotation}
              ref={internalRef} />
      <span style={{marginLeft: '3px'}}>°</span>
    </div>
  ) : (
    <>
      <img src="/assets/wind-arrow.png"  onClick={handleEdit}
          style={arrowStyle}
      ></img>
      <span onClick={handleEdit} style={{fontSize: '14px', fontStyle: 'italic', position:'relative', top: '10px', left: '-5px', cursor: 'pointer'}}>{props.rotation + ' °'}</span>
    </>
  ); 
  } 
export default WindArrow;